import React from 'react';
import styles from './MatrixPageFooter.scss';
import rpCookie from 'rp-cookie';

function MatrixPageFooter() {
  const userIdCookie = rpCookie.sharedPermanent.get('rp_uid');
  const backUrl = `${window.location.origin}/subscriptions/`;

  if (userIdCookie) {
    return null;
  }

  return (
    <a
      href={`/api/auth/login/?signup=true&state=${btoa(backUrl)}&force=true`}
      className={styles.matrixSignUpLink}
        >
            Free tips to your inbox, Sign up for our newsletter
    </a>
  );
}

export default MatrixPageFooter;
